import React from 'react';
import { Link } from 'react-router-dom';
import { Hammer, Phone, Mail, MapPin, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative pt-16 pb-8 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://assets.auxodev.dk/assets/10d78498-60e6-4cb8-8f48-f81fe0e15f7b/bb82383b-ae8d-44ef-9ccb-1fd5c6383e68.jpg" 
          alt="Footer background" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/90 backdrop-blur-sm"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-6">
            <div className="flex items-center">
              <img 
                src="https://assets.auxodev.dk/assets/10d78498-60e6-4cb8-8f48-f81fe0e15f7b/df7088a1-dc82-4365-be5b-14546feb0899.png" 
                alt="SL. Flise & Murer Logo" 
                className="h-20 w-auto object-contain"
              />
            </div>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/p/SL-Flise-og-murerforretning-100049126461160/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-orange-600 hover:text-orange-500 transition-colors"
              >
                <Facebook className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Hurtige links</h3>
            <ul className="space-y-4 text-sm text-white">
              <li><a href="/#om-os" className="hover:text-orange-500 transition-colors">Om os</a></li>
              <li><Link to="/projekter" className="hover:text-orange-500 transition-colors">Projekter</Link></li>
              <li><a href="/#kontakt" className="hover:text-orange-500 transition-colors">Kontakt</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-6">Vores ydelser</h3>
            <ul className="space-y-4 text-sm text-white">
              <li>Flisearbejde</li>
              <li>Murerarbejde</li>
              <li>Reparationer</li>
              <li>Badeværelser</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-6">Kontakt os</h3>
            <ul className="space-y-4 text-sm text-white">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-white shrink-0" />
                <span>+45 61 67 83 52</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-white shrink-0" />
                <span>steffanlund@gmail.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-white shrink-0" />
                <span>Strucksalle 36, 6270 Tønder</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-white">
          <div className="flex flex-col items-center md:items-start space-y-2">
            <p className="text-xs opacity-80">
              © {new Date().getFullYear()} SL. Flise- og murerforretning. Alle rettigheder forbeholdes.
            </p>
            <div className="flex items-center space-x-2">
              <span className="text-[10px] uppercase tracking-widest opacity-50">Powered by</span>
              <img src="/images/auxo_logo_white.png" alt="Auxo Logo" className="h-4 w-auto opacity-80 hover:opacity-100 transition-opacity" />
            </div>
          </div>
          <div className="flex space-x-6 text-xs opacity-80">
            <span>CVR: 38975978</span>
            <a href="#" className="hover:text-orange-500 transition-colors">Privatlivspolitik</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
